import { FormInput, FormTextarea, FormSelect } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { DESCRIPTION, KIT_TYPE, NAME, Kit_options } from "../consts";
import { X } from "lucide-react";
import { capitalize } from "@/lib/utils";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isMobile,
    action,
    isEdit,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {capitalize(action || "")} KIT
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[100px] px-1">
              <div className="grid grid-cols-1 gap-[25px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="KIT Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled={isView}
                />
                <FormSelect
                  name={KIT_TYPE}
                  control={form.control}
                  label="KIT Type"
                  placeholder="Please enter"
                  error={errors[KIT_TYPE]?.message}
                  isRequired={requiredFields.includes(KIT_TYPE)}
                  disabled={isView}
                  options={Object.entries(Kit_options).map(([value, label]) => ({
                    value,
                    label,
                  }))}
                />
                <FormTextarea
                  name={DESCRIPTION}
                  control={form.control}
                  label="Description"
                  placeholder="Please enter"
                  error={errors[DESCRIPTION]?.message}
                  isRequired={requiredFields.includes(DESCRIPTION)}
                  disabled={isView}
                  className="h-[200px]"
                  maxLength={1000}
                />
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-3 absolute bottom-0 w-full bg-white pb-[25px] z-[3]">
              <Button variant="outline" type="button" onClick={onCancel}>
                Cancel
              </Button>
              {isView ? (
                <></>
              ) : (
                <Button type="submit">{isEdit ? "Update" : "Submit"}</Button>
              )}
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
